export default "__VITE_ASSET__BRjWZ$I7__"